/* src/app/component/progetto/progetto.component.css */
:host-context(app-progetto) .gridL {
  display: grid;
}
:host-context(app-progetto) .gridL {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
:host-context(app-progetto) .gridL {
  gap: 1rem;
}
@media (min-width: 640px) {
  :host-context(app-progetto) .gridL {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (min-width: 768px) {
  :host-context(app-progetto) .gridL {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  :host-context(app-progetto) .gridL {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {
  :host-context(app-progetto) .gridL {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
:host-context(app-progetto) .max-w-sm {
  max-width: 29rem;
}
:host-context(app-progetto) .mt-0 {
  margin-top: 0 !important;
}
:host-context(app-progetto) .filed-invalid {
  color: red;
}
:host-context(app-progetto) .form_badge label {
  padding-right: 1.5rem !important;
}
/*# sourceMappingURL=progetto.component.css.map */
